// Features/Privacy-Settings/mod.ts
function linkSettings() {
  const Selector_Links = `[ href = '#Privacy-Settings' ]`;
  document.querySelectorAll(Selector_Links).forEach((link) => {
    link.addEventListener("click", () => {
      UC_UI.showSecondLayer();
    });
  });
}
window.addEventListener("CookieConsent", setup);
function setup(event) {
  const { event: type, action } = event.detail;
  if (type !== "consent_status")
    return;
  if (action !== "onInitialPageLoad")
    return;
  linkSettings();
}
